import "./aulaLista.css"
import { useEffect, useState } from "react"
import { getDocumentoUnico, filtro, deleteItem, deletarVariosRegistros } from "../../../firebase/CRUD"
import {documentId} from "firebase/firestore";
import { replace, useNavigate, useParams } from "react-router-dom"
import { FichaAulaTurma } from "../../layout/Fichas"
import BackButton from '../../layout/BackButton'
import { BiPencil } from "react-icons/bi";
import LinkButton from "../../layout/LinkButton";
import { useAuth } from "../../../hooks/AuthContext";
import { Navigate } from "react-router-dom";
import { FichaTurmasAulas } from "./FichaAula";
import Relatorio from "../../layout/Relatorio/Relatorio";
import Button from "../../layout/Button/Button";
import AulaAdd from "./AulaAdd";
import { Trash } from "lucide-react";

export default function ListaTurmas(){
    const {usuario} = useAuth()
    const {id} = useParams()
    const [aulaInfo, setAulaInfo] = useState({})
    const [listaTurmas, setListaTurmas] = useState([])
    const [cadastramento,setCadastramento] = useState(false)
    const [geral, setGeral] = useState({})
    const navigate = useNavigate()
    useEffect(()=>{
        const computarDados = (doc)=>{
            let Bib = 0
            let Rev = 0
            let Pres = 0
            let Ofer = 0
            let totAlunos = 0
            let totAusentes = 0
            let totVisitantes = 0
        
            if(doc){
                doc.forEach((element)=>
                {
                    if(element.matriculados){
                        Bib += element.biblias
                        Pres += element.presencas
                        Rev += element.revistas
                        Ofer += Number(element.totalOfertas)
                        totAlunos += element.matriculados
                        totAusentes += element.ausentes
                        totVisitantes += Number(element.visitantes)
                    }
                }) 
                setGeral({
                    matriculados: totAlunos,
                    presencas: Pres,
                    totalOfertas: Ofer,
                    ausentes: totAusentes,
                    visitantes: totVisitantes,
                    biblias: Bib,
                    revistas: Rev
                })
            }
            setListaTurmas(doc)
        }

        const localizarTurma = (doc)=>{
            doc.forEach(e =>{
                if(e.idTurma == usuario.turma){
                    console.log("Turma: ",doc, "\nUsuario: ",usuario)
                    return navigate(`/aulachamada/${e.id}`,{replace:true})   
                }
            })
        
        
            
        }
        const listasTurma = (doc)=>{
            if(doc.turmas.length && doc.turmas.length > 0){
                if(usuario.perfil == 'adm'){
                    filtro("aulaTurma",documentId(),"in",doc.turmas,computarDados,usuario.idEscola)
                }
                if(usuario.perfil == 'professor'){
                        filtro("aulaTurma",documentId(),"in",doc.turmas,localizarTurma,usuario.idEscola)
                }
            } 
            setListaTurmas([])
            setAulaInfo(doc)
      
        } 
        getDocumentoUnico("aulas",id,listasTurma,usuario.idEscola)
        return
    },[])

    const ativarCadastramento = ()=>{
        setCadastramento(true)
    }
    const desativarCadastramento = ()=>{
        setCadastramento(false)
    }
    const deletarCadastro = ()=>{
        if(window.confirm("Após apagar, os dados desse registro não serão recuperados, deseja mesmo apagar?")){
            deletarVariosRegistros(usuario.idEscola,aulaInfo.turmas)
            deleteItem('aulas',aulaInfo.id,usuario.idEscola)
            navigate(-1,{replace:true})
            
        }
    }
    return(
        <div className='container'>
            <div className='cabecalhoAulas'>
                <div style={{
                    display:"flex",
                    width:"100%",
                    justifyContent:"space-between"
                }}>
                    <BackButton/>
                    {aulaInfo.licao  
                    &&
                    <h2>Lição {aulaInfo.licao}</h2>}
                    <div style={{gap:'10px'}}>
                        <BiPencil
                            onClick={
                                ativarCadastramento
                            }
                            size={30}/>
                        <Trash 
                        onClick={deletarCadastro}
                        size={30}/>
                    </div>
                </div>
            </div>
            {
                listaTurmas.length == 0 
                && <p>Carregando turmas...</p>
            }
            {listaTurmas.length > 0 && 
                listaTurmas.map((item,id)=>
                    <FichaTurmasAulas 
                        key={id}
                        id={item.id}   
                        nomeTurma={item.nome}
                        situacao={item.situacao}
                    />
                )
            }
            {cadastramento && <AulaAdd cadastramento={desativarCadastramento} edit={aulaInfo}/>}
            <h3>Resumo Geral</h3>
            {geral && <Relatorio aula={geral}/>}

            <Button onClick={()=>{
                if(window.confirm('Após fechar, não poderá ser editado, deseja continuar?')){
                    navigate('/relatorio',{state:{
                        listaTurmas:listaTurmas,
                        geral:geral,
                        dadosAula:aulaInfo
                    }})
                } else return
            }}>
                Fechar Relatório
            </Button>
            
        </div>
    )
}